module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"now":"now"},"de":{"now":"jetzt"},"fr":{"now":"maintenant"},"it":{"now":"ora"}}')
  delete Component.options._Ctor
}
